import "@fontsource/unbounded/400.css";
import "@fontsource/unbounded/500.css";
import "@fontsource/unbounded/600.css";
import "@fontsource/instrument-sans/400.css";
import "@fontsource/instrument-sans/500.css";
import "@fontsource/instrument-sans/600.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { SiteLayout } from "./components/layout/SiteLayout";
import { AuthProvider, RequireAdmin } from "./components/admin/AuthContext";
import Home from "./pages/Home";
import ServicesIndex from "./pages/ServicesIndex";
import ServiceDetail from "./pages/ServiceDetail";
import BrendanPage from "./pages/BrendanPage";
import Shop from "./pages/Shop";
import ContactPage from "./pages/Contact";
import Track from "./pages/Track";
import AdminLogin from "./pages/AdminLogin";
import AdminInbox from "./pages/AdminInbox";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/brendan" element={<BrendanPage />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/track" element={<Track />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
          <Route path="/admin" element={<AuthProvider><RequireAdmin><AdminInbox /></RequireAdmin></AuthProvider>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
